import { Loader } from "@components/loader/loader";
import { PressCardExample } from "@components/press_card/press_card_example";
import { PressItemForm } from "@components/press_item_form/press_item_form";
import { useFetchPressItem } from "@hooks/use_fetch_press_item";
import React, { type FC } from "react";

const PressItemCreatePage: FC = () => {
  const { pressItem, loading } = useFetchPressItem({});

  if (loading) {
    return <Loader />;
  }
  if (!pressItem) {
    return null;
  }

  return (
    <div className="content">
      <header>
        <h1>Create Press</h1>
      </header>
      <p>This page is where you can add a new press item to the system.</p>
      <div className="press-item--prelude">
        <PressItemForm pressItem={pressItem} />
        <PressCardExample />
      </div>
    </div>
  );
};

export { PressItemCreatePage };
